<template>
    <div class="main-box flex flex-col flex-y-center">

        <div class="cell-box   flex flex-col flex-start">
            <div class="search-box flex flex-y-center">
                <img v-for="(item,index) in transferCustomerList" :key="index" @click="customerClick(item)" :src="item.avatar"
                    class="search-ava" alt="">
                <van-icon v-if="transferCustomerList.length <= 0" name="search" color="#CCCCCC" class="search-icon" />
                <input v-model="keyWords" @keyup.13="getList" @input="getList" placeholder="输入顾客备注/昵称查找" type="search"
                    class="search-input flex-1">
            </div>
            <div class="child-list-box flex-1">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList"
                        :immediate-check="false">
                        <div v-if="list.length >0">
                            <div class="cell flex flex-y-center flex-between" v-for="(item,index) in list" :key="index"
                                @click="customerClick(item)">
                                <van-checkbox v-model="item.isCheck"></van-checkbox>
                                <img :src="item.avatar" class="ava" alt="" />
                                <div class="name flex-1">{{item.name}}</div>
                                <div class="tag">{{item.empName}}添加</div>
                            </div>
                        </div>
                        <div v-else class="empty">没有找到“{{keyWords}}”相关结果</div>
                    </van-list>
                </van-pull-refresh>
            </div>
            <div class="btn" @click="confirm">确定</div>
        </div>
    </div>
</template>
  
<script>

import request from "@/utils/request";
import { mapState } from 'vuex';

export default {
    name: "specifiedSearch",
    data() {
        return {
            keyWords: '',
            list: [],
            customerList: [],
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            total: 0,
        };
    },
    mounted() {
        this.getList()
    },
    computed: {
        ...mapState({
            transferCustomerList: (state) => state.inherit.transferCustomerList,
            selectedCustomerIds: (state, getters) => getters.selectedCustomerIds
        }),
    },
    methods: {
        // 获取
        getList() {
            if (this.refreshing) {
                this.page = 1
                this.refreshing = false;
            }
            this.loading = true
            request({
                url: `/workEmployee/empAllContactList?limit=10&page=${this.page}&keyWords=${this.keyWords}`,
                method: "get",
            })
                .then((res) => {
                    this.customerList = this.page == 1 ? res.data.list : this.list.concat(res.data.list);
                    this.list = this.customerList.map((item) => ({
                        ...item,
                        isCheck: this.selectedCustomerIds.includes(item.id)
                    }))
                    this.page += 1;
                    this.total = res.data.total;
                }).catch(() => {
                    this.finished = true
                }).finally(() => {
                    this.loading = false;
                    if (this.customerList.length >= this.total) {
                        this.finished = true;
                    }
                });

        },
        // 
        updateTransferCustomerList(customerItem) {
            this.$store.commit('inherit/SET_TRANSFER_CUSTOMER', customerItem)
        },
        // 
        customerClick(customerItem) {
            customerItem.isCheck = !customerItem.isCheck
            this.updateTransferCustomerList(customerItem)
        },
        // 确定后返回
        confirm() {
            this.$router.go(-1)
        },
        // 清空list数据
        onRefresh() {
            // 清空列表数据
            this.finished = false;
            this.loading = true;
            this.getList();
        }
    },
};
</script>

<style scoped lang="less">
.main-box {
    width: 750px;
    height: 100%;
    background: #fff;
    overflow-y: auto;
    position: relative;
}
.search-box {
    width: 100%;
    min-height: 124px;
    padding: 25px 30px;
    background-color: #fff;
    flex-wrap: wrap;
    border-bottom: 1px solid #d7d7d7;
    .search-icon {
        font-size: 32px;
        margin-right: 30px;
    }
    .search-input {
        border: none;
        height: 40px;
        font-size: 32px;
    }
    .search-ava {
        width: 70px;
        height: 70px;
        margin-right: 20px;
    }
}

.child-list-box {
    height: 67vh;
    justify-content: space-between;
    // margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
}
.cell-box {
    width: 100%;
    padding: 30px;
    height: 100%;
    .empty {
        margin-top: 269px;
        font-size: 28px;
        font-weight: 400;
        color: #a0acb5;
        text-align: center;
    }
    .cell {
        width: 100%;
        height: 132px;
        border-bottom: 1px solid #d7d7d7;
        .ava {
            width: 70px;
            height: 70px;
            margin-left: 30px;
            margin-right: 20px;
            border-radius: 10px;
        }
        .name {
            font-size: 32px;
            font-weight: 400;
            color: #35434c;
        }

        .tag {
            font-size: 26px;
            font-weight: 400;
            color: #a0acb5;
        }
    }
}
.btn {
    width: 630px;
    height: 88px;
    background: #333f48;
    border-radius: 44px;
    font-size: 32px;
    font-weight: 400;
    color: #ffffff;
    line-height: 88px;
    letter-spacing: 1px;
    text-align: center;
    // position: absolute;
    // bottom: 150px;
    margin-left: 20px;
}
:deep(.van-checkbox) {
    margin-bottom: 0 !important;
}
input::-webkit-input-placeholder {
    color: #a0acb5;
    font-size: 28px;
}
input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #a0acb5;
    font-size: 28px;
}
input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #a0acb5;
    font-size: 28px;
}
input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #a0acb5;
    font-size: 28px;
}
</style>